let allowNextPop = false
let restaurando = false
let instalado = false

function onPopState(event: PopStateEvent): void {
    if (restaurando) {
        event.stopImmediatePropagation()
        return
    }
    if (allowNextPop) {
        allowNextPop = false
        return
    }
    event.stopImmediatePropagation()
    restaurando = true
    setTimeout(() => {
        try {
            history.go(1)
        } finally {
            setTimeout(() => {
                restaurando = false
            }, 50)
        }
    }, 0)
}

function patchHistory(): void {
    const origBack = history.back.bind(history)
    const origGo = history.go.bind(history)

    history.back = () => {
        allowNextPop = true
        origBack()
    }

    history.go = (delta?: number) => {
        if (typeof delta === 'number' && delta < 0) {
            allowNextPop = true
        }
        origGo(delta)
    }
}

export function instalarBloqueoAtrasNavegador(): void {
    if (instalado || typeof window === 'undefined') {
        return
    }
    instalado = true
    patchHistory()
    window.addEventListener('popstate', onPopState, true)
}

instalarBloqueoAtrasNavegador()
